export default "__VITE_ASSET__DZtLASk5__"